import { Model } from 'modules/core/lib/mobx-rest'

export interface ITaskFile {
  id?: string
  task_id?: string
  filename: string
  path?: string
  file?: File
}

class TaskFile extends Model<ITaskFile> {
  static urlRoot() {
    return '/tasks/tasks_files'
  }

  get filename() {
    return this.attributes.filename
  }

  get path() {
    return this.attributes.path
  }
}

export default TaskFile
